// extracted by mini-css-extract-plugin
export default {"downloadAppPopup":"index_downloadAppPopup__ZZQ4y"};